import { Component, ViewParent } from 'angular-ts-decorators';
import { faExpand, faCompress } from '@fortawesome/pro-solid-svg-icons';

/**
 * # swCardExpand
 *
 * Expand toggle component. Requires {@link coreModule.component:swCard
 * swCard} controller to be available.
 *
 * # Example
 * <pre>
 *   <sw-card-expand></sw-card-expand>
 * </pre>
 */
@Component({
  selector: 'swCardExpand',
  template: require('./sw-card-expand.html').default,
})
export class SwCardExpandComponent {
  @ViewParent('^') swCard: any;
  faExpand = faExpand;
  faCompress = faCompress;

  constructor() {
    'ngInject';
  }

  expandToggle() {
    this.swCard.expandToggle();
  }
}
